// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host {
  display: block;
  position: fixed;
  bottom: 25px;
  right: 25px;
  color: #4b5b70;
  z-index: -1;
}
:host .trigger {
  border: 0;
  background-color: var(--cs-secondary-color);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);
  outline: 0;
  color: white;
}
:host .trigger:focus {
  outline: 0;
}
:host .cs-socket-disconnected {
  color: #ff4c4c;
  background-color: #ffc7ce;
  margin: 0;
  text-align: center;
  padding: 0.25rem;
}

.content {
  background-color: white;
  width: 250px;
  box-shadow: 0 0 14px 0 rgba(45, 62, 80, 0.25);
  border-radius: 7px;
  overflow: hidden;
}
.content h6 {
  background-color: #4b5b70;
  color: white;
  margin: 0;
  padding: 0.5rem;
  display: flex;
}
.content h6 .in-queue-count {
  margin-left: auto;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
}
.content .btn-terminate,
.content .btn-pause {
  border: 0;
  flex: 1;
  border-radius: 0;
}
.content .btn-terminate {
  background-color: #ff4c4c;
}
.content .btn-pause {
  background-color: #e08600;
}
.content .no-calls {
  min-height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: Roboto-Medium;
}
.content .no-calls p {
  margin: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
